import { render, staticRenderFns } from "./xxy-progress.vue?vue&type=template&id=66a539f4&scoped=true"
import script from "./xxy-progress.vue?vue&type=script&lang=js"
export * from "./xxy-progress.vue?vue&type=script&lang=js"
import style0 from "./xxy-progress.vue?vue&type=style&index=0&id=66a539f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a539f4",
  null
  
)

export default component.exports